import { render, staticRenderFns } from "./employees-by-sex-widget.vue?vue&type=template&id=4d3f5f10&scoped=true&"
import script from "./employees-by-sex-widget.vue?vue&type=script&lang=js&"
export * from "./employees-by-sex-widget.vue?vue&type=script&lang=js&"
import style0 from "./employees-by-sex-widget.vue?vue&type=style&index=0&id=4d3f5f10&prod&lang=scss&scoped=true&"
import style1 from "./employees-by-sex-widget.vue?vue&type=style&index=1&id=4d3f5f10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f5f10",
  null
  
)

export default component.exports